import * as React from "react"
const AddcourseCover = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19.469 3.793h-14a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-14a2 2 0 0 0-2-2Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.969 10.793a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM21.469 15.793l-5-5-11 11"
    />
  </svg>
)
export default AddcourseCover
